/**
 * Comu Mega Menu
 * 1. Hover bridge: keeps dropdown open while mouse travels from trigger to panel
 *    (solves the gap when nav items wrap to multiple rows)
 * 2. Products sidebar: panel switching on hover
 */
(function() {
  'use strict';

  function initHoverBridge() {
    document.querySelectorAll('.comu-mega-wrapper').forEach(function(wrapper) {
      var dropdown = wrapper.querySelector('.comu-mega');
      if (!dropdown) return;

      function open() {
        document.querySelectorAll('.comu-mega-wrapper.is-open').forEach(function(other) {
          if (other !== wrapper) other.classList.remove('is-open');
        });
        wrapper.classList.add('is-open');
      }

      function close() {
        wrapper.classList.remove('is-open');
      }

      wrapper.addEventListener('mouseenter', open);
      wrapper.addEventListener('mouseleave', close);

      dropdown.addEventListener('mouseenter', open);
      dropdown.addEventListener('mouseleave', close);
    });
  }

  function initProductsPanelSwitch() {
    document.querySelectorAll('.comu-mega--products').forEach(function(mega) {
      var sidebarItems = mega.querySelectorAll('.comu-mega__sidebar-item');
      var panels = mega.querySelectorAll('.comu-mega__panel');

      sidebarItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          var targetId = item.getAttribute('data-panel-target');
          if (!targetId) return;

          sidebarItems.forEach(function(si) { si.classList.remove('is-active'); });
          item.classList.add('is-active');

          panels.forEach(function(p) { p.classList.remove('is-active'); });
          var targetPanel = document.getElementById(targetId);
          if (targetPanel) targetPanel.classList.add('is-active');
        });

        item.addEventListener('click', function(e) { e.preventDefault(); });
      });
    });
  }

  function init() {
    initHoverBridge();
    initProductsPanelSwitch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
